module.exports = __webpack_public_path__ + "icon_arrow.png?093a9463fa06c4185dbd378851a2b76e";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icon_arrow.png
// module id = 531
// module chunks = 0